import { CombinedManualAdjustmentType } from '@aloft/toolkit-shared';

export const ADJUSTMENT_LABELS: Record<CombinedManualAdjustmentType, string> = {
  adu: 'ADU',
  attic: 'Attic',
  barn: 'Barn',
  basement: 'Basement',
  bathAboveGrade: 'Baths',
  bathBelowGrade: 'Baths (Below Grade)',
  bedrooms: 'Bedrooms',
  belowGradeANSI: 'Below Grade (per ANSI)',
  bonusRoom: 'Bonus Room',
  concessions: 'Financial Concessions',
  condition: 'Condition',
  dateOfSale: 'Date of Sale',
  externalObsolescence: 'External Obsolescence',
  fireplace: 'Fireplace',
  foundation: 'Foundation',
  functionalUtility: 'Functional Utility',
  garageCarport: 'Garage / Carport',
  gla: 'GLA (Use this one if you are using the new Adjustment Grid)',
  locationView: 'Location and View',
  mainDwelling: 'GLA',
  manual: 'Manual Cost',
  manufactured: 'Mfd. Dwelling',
  pool: 'Pool',
  poolSpa: 'Pool/Spa',
  porchPatioDeck: 'Porch/Patio/Deck',
  quality: 'Quality',
  shed: 'Shed',
  site: 'Site size, Location & View',
  termsOfSale: 'Terms of Sale',
  units: 'Number of Units',
  workshop: 'Workshop',
};
